export default {
  appTitle: 'Sync',
  title: 'Osigu Sync - RIPS Premium',
  filterLabel: 'Aplicar filtros',
  resultLabel: 'Resultados',
  lastUpdateLabel: 'Última actualización',
  emptyDataLabel: 'No se encontraron resultados',
  tryAgainLabel: 'Intente buscando otro término o ',
  cleanFilters: 'limpiando los filtros',
  filtersAppliedLabel: ' aplicados',
  paginationSizeLabel: 'Resultados por página',
  cleanFilter: 'Limpiar filtros',
  filters: {
    searchCode: 'Buscar por No. de documento',
    branchIdentifiers: 'Sede / Subsede',
    status: 'Estado',
    invoiceType: 'Tipo Factura/nota',
    payerType: 'Tipo de pagador',
    payer: 'Pagador',
    agreement: 'Convenio',
    naturalPerson: 'Identificación del particular',
    invoiceInitialDate: 'Fecha inicial factura',
    invoiceFinalDate: 'Fecha final factura',
    dateFilterType: {
      label: 'Filtrar fecha por:',
      generation: 'Generación',
      validation: 'Validación'
    },
    confirm: 'Aplicar filtros'
  },
  ripsGrid: {
    status: 'Estado',
    invoiceType: 'Tipo Factura/nota',
    invoice: 'Factura/nota',
    reference: 'Referencia',
    nit: 'NIT',
    payer: 'Pagador',
    agreement: 'Convenio',
    invoiceDate: 'Fecha Factura',
    ripsValue: 'Valor RIPS',
    netValue: 'Valor Neto',
    grossValue: 'Valor Bruto',
    validationDate: 'Fecha de validación',
    uniqueValidationCode: 'CUV',
    electronicInvoiceUniqueCode: 'CUFE'
  },
  tabs: {
    rips: 'RIPS',
    dashboard: 'Dashboard'
  },
  filtersRequired: 'Campos requeridos faltantes',
  notificationsTittleLabel:'Incluir notificaciones en el archivo CUV',
  notificationsLabel:'¿Desea agregar notificaciones al archivo CUV? Esto permitirá un mejor seguimiento y actualización de la información según la ley',
  withNotificationsLabel:'Si, incluir',
  withoutNotificationsLabel:'No, gracias',
}
